<!--
For other possible props for a-statistic-countdown:
@see https://2x.antdv.com/components/statistic

If we need a different default values compared
to the default values of the library apply it here
-->

<template>
  <a-statistic-countdown
    :prefix="label"
    :suffix="suffix"
    :value="countdownTimerValue"
    @finish="onResendFinish"
    :format="format"
    valueStyle="font-size: inherit"
  />
</template>

<style lang="scss"></style>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { config } from "@/shared/utils/config";
import moment from "moment";
import { i18nTranslate } from "@/plugins/i18n";

export default defineComponent({
  props: {
    format: {
      type: String,
      default: "mm:ss",
    },
    label: {
      type: String,
      default: i18nTranslate("Resend in"),
    },
    suffix: {
      type: String,
    },
    // Being passed by PhoneVerification
    countdownValue: {
      type: [Number, moment],
    },
    // for more specific prop value
    countdownValueInMs: {
      type: Number,
      default: null,
    },
  },
  emits: ["finish"],
  setup(props, { emit }) {
    /** Fetch countdown timer value */
    const countdownTimerValue = computed(() => {
      // If from PhoneVerification, directly pass the value
      if (props.countdownValue) {
        return props.countdownValue;
      }
      // Other components e.g. SecurityProtocols
      return Date.now() + (props.countdownValueInMs ?? config.countdownTimer);
    });

    return {
      onResendFinish: () => {
        emit("finish");
      },
      config,
      countdownTimerValue,
    };
  },
});
</script>
